module.exports = __webpack_public_path__ + "img/arrow-back.e64f7414.png";